import Layout from "../../components/Home/layout";
import FirstBlock from "../../components/AboutUs/FirstBlock";
import Certifications from "../../components/AboutUs/certifications";
import CardBlock from "../../components/AboutUs/cardBlock";
import styles from "./styles.module.scss";
import { useTitle } from "../../hooks";

const AboutUs = () => {
  useTitle("About Train GRC | Practical Cloud Audit Training");
  return (
    <Layout active="AboutUs" color="#F2EFEE">
      <article className={styles.aboutUs}>
        <FirstBlock />
        <Certifications />
        <CardBlock />
      </article>
    </Layout>
  );
};
export default AboutUs;
